import { api } from "./client";

export const IssueReportAPI = {
  create: async (message) => {
    const { data } = await api.post('/api/v1/issue-reports', { message });
    return data;
  },

  getAll: async (status) => {
    const params = status ? { status } : {};
    const { data } = await api.get("/api/v1/issue-reports", { params });
    return data;
  },

  getById: async (id) => {
    const { data } = await api.get(`/api/v1/issue-reports/${id}`);
    return data;
  },

  updateStatus: async (id, status) => {
    const { data } = await api.patch(`/api/v1/issue-reports/${id}/status`, { status });
    return data;
  },

  delete: async (id) => {
    await api.delete(`/api/v1/issue-reports/${id}`);
    return true;
  },
};
